<div class="row">
  <div class="accordions-container d-flex">
    <div class="filter-body" [class.showfilter]="!showFilter">
      <div class="filterContainer" (click)="setShowFilter()">
        <i
          style="font-size: 1.5rem; margin-right: -4px"
          [tooltip]="showFilter ? ('ClientApp.Review.Close' | translate) : ('ClientApp.Review.Open' | translate)"
          [class.icon-assignment_return-o]="!showFilter"
          [class.icon-exit_to_app-o]="showFilter"></i>
      </div>
      <div *ngIf="showFilter" class="accordion-container page">
        <div>
          <div class="cardbody">
            <date-filter-review *ngIf="showDateFilter" [hasIncludeTime]="hasIncludeTime" name="generalFilter" [showAllDays]="showAllDays"> </date-filter-review>
            <ng-content select="[review-static-filters]"></ng-content>
            <section style="margin-top: 2px">
              <sepidz-filter-item-review #filterItem name="filterItem" [title]="'ClientApp.Review.Filter' | translate"> </sepidz-filter-item-review>
            </section>

            <div>
              <ssg-select
                [label]="'ClientApp.Review.Filter' | translate"
                [dataList]="reviewService.ReviewReportList"
                textFieldName="Title"
                (valueChange)="CustomFilterChange($event)"
                [group]="formGroup"
                name="SaveFilters"
                class="select-filter"></ssg-select>
              <div *ngIf="isFilterActive" class="d-flex save-file">
                <ssg-button class="save" [label]="'ClientApp.Review.Save' | translate" (click)="ShowReportTitle()"></ssg-button>
                <ssg-button
                  (click)="onClearReviewReport()"
                  *ngIf="this.selectedReviewReport?.Id && hasSavebutton"
                  class="save"
                  [label]="'ClientApp.Review.Delete' | translate"></ssg-button>
              </div>
            </div>
          </div>
        </div>
        <ng-content select="[review-filters]"></ng-content>
      </div>
    </div>
    <div class="content page">
      <ng-content select="[review-content]"></ng-content>
    </div>
  </div>
</div>
